import { extractErrorMessages } from '@fukuri-admins/ui/common/Form/logics/extractErrorMessages';
import { ComponentProps } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import { SelectField } from '..';

type SelectFieldProps = ComponentProps<typeof SelectField>;

type Props = {
  name: string;
  select: Omit<SelectFieldProps['select'], 'onValueChange' | 'value'>;
  fieldWrapperProps: Omit<SelectFieldProps['fieldWrapperProps'], 'htmlFor' | 'errorMessages'>;
};

export const SelectFieldController: React.FC<Props> = ({ name, fieldWrapperProps, select }) => {
  const { control } = useFormContext();

  const {
    field: { value, onChange, onBlur, disabled },
    fieldState: { error },
  } = useController({ control, name });

  return (
    <SelectField
      fieldWrapperProps={{
        htmlFor: name,
        errorMessages: extractErrorMessages(error),
        ...fieldWrapperProps,
      }}
      select={{
        placeholder: select.placeholder,
        options: select.options,
        value,
        onValueChange: onChange,
        clearable: select.clearable,
        onBlur,
        disabled: select.disabled || disabled,
      }}
    />
  );
};
